import { getStudentsForGroup, orEmptyArray } from '@lms/api-client/backend';
import useSWR from 'swr';
import { useLocale, useTranslations } from 'use-intl';
import SessionTable from '@/features/groups/components/session-table';
import { takeLocaleString } from '@/lib/translate';

export default function PersonList({
  groupId,
  groupName,
  canManage,
}: {
  groupId: number;
  groupName: string;
  /** Whether the viewer may remove students from the group. */
  canManage: boolean;
}) {
  const locale = useLocale();
  const t = useTranslations('admin');
  const { data: students, mutate } = useSWR(
    ['group-students', groupId, locale],
    () => orEmptyArray(getStudentsForGroup(groupId, locale)),
  );

  if (students === undefined) {
    return (
      <div className="text-muted-foreground m-8 text-center">
        {t('loading')}
      </div>
    );
  }

  const courses = students.reduce((agg: string[], student) => {
    const add = Object.keys(student.courseStatus ?? {}).filter(
      (name) => !agg.includes(name),
    );
    return [...agg, ...add];
  }, [] as string[]);

  const curriculums = students.reduce(
    (agg, student) => {
      const add = student.curriculumName ?? '';
      if (add !== undefined && !agg.some((c) => c[0] === add)) {
        agg.push([
          add,
          takeLocaleString(
            locale,
            student.curriculumNameTranslated ?? student.curriculumName,
          ) ?? add,
        ]);
      }
      return agg;
    },
    [] as [string, string][],
  );

  return (
    <SessionTable
      students={students}
      curriculums={curriculums}
      courses={courses}
      groupName={groupName}
      canManage={canManage}
      onChanged={() => mutate()}
    />
  );
}
